// extracted by mini-css-extract-plugin
module.exports = {"Switch":"styles-module--Switch--t85RO","IconMoon":"styles-module--IconMoon--3y3Bl","IconSun":"styles-module--IconSun--1hKCi"};